<script>
  import { Router, Link, Route } from 'svelte-navigator';
  import RouteTransition from '../RouteTransition.svelte';
  import { fly, blur } from 'svelte/transition';
  import Paths from '../Utils/Paths.svelte';

  import {
    idTrappe,
    choix,
    type,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    couleur,
    trappePath,
  } from '../stores.js';

  import ChoixTrappe from '../Pages/ChoixTrappe.svelte';
  import TitleNNumber from '../ComponentsInProcess/TitleNNumber.svelte';
  import BtnPage from '../ComponentsInProcess/btnPageMetalique.svelte';
  import BtnPageEtancheite from '../ComponentsInProcess/BtnPageEtancheite.svelte';
  import RangeSliderEtancheiteEauAir from '../ComponentsInProcess/range-slider-4-etancheite-eau-air.svelte';
  import RangeSliderEtancheiteAirPoussiere from '../ComponentsInProcess/range-slider-4-etancheite-air-poussiere.svelte';
  import BtnInputPage from '../ComponentsInProcess/range-slider-1-metallique.svelte';
  export let idFiche;
</script>

{#if idFiche == 1}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageEtancheite
        idFiche="{idFiche}"
        idBtn="1"
        titre="{'Air / Poussière'}"
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageEtancheite
        idFiche="{idFiche}"
        idBtn="2"
        titre="{'Eau / Air / Poussière / Fumée'}"
      />
    </div>
  </div>
{:else if idFiche == 2}
  {#if $type == 'Air / Poussière'}
    <div class="grid grid-cols-3 gap-4">
      <div in:fly="{{ x: 100, duration: 800 }}">
        <BtnPageEtancheite
          idFiche="{idFiche}"
          idBtn="3"
          titre="{'12,5 mm (réduction de 46 db)'}"
        />
      </div>
      <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
        <BtnPageEtancheite
          idFiche="{idFiche}"
          idBtn="4"
          titre="{'15 mm (réduction de 46 db)'}"
        />
      </div>
      <div in:fly="{{ delay: 300, x: 100, duration: 800 }}">
        <BtnPageEtancheite
          idFiche="{idFiche}"
          idBtn="5"
          titre="{'25 mm (réduction de 48 db)'}"
        />
      </div>
    </div>
  {:else}
    <div class="grid grid-cols-3 gap-4">
      <div in:fly="{{ x: 100, duration: 800 }}">
        <BtnPageEtancheite
          idFiche="{idFiche}"
          idBtn="3"
          titre="{'12,5 mm (réduction de 47 db)'}"
        />
      </div>
      <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
        <BtnPageEtancheite
          idFiche="{idFiche}"
          idBtn="4"
          titre="{'2x 12,5 mm (réduction de 49 db)'}"
        />
      </div>
    </div>
  {/if}
{:else if idFiche == 3}
  {#if $trappePath[0] == 1}
    <RangeSliderEtancheiteEauAir
      idFiche="{idFiche}"
      titre="{'Longueur'}"
      soustitre="{'avec une l'}"
    />
  {:else}
    <RangeSliderEtancheiteAirPoussiere
      idFiche="{idFiche}"
      titre="{'Longueur'}"
      soustitre="{'avec une l'}"
    />
  {/if}
{:else if idFiche == 4}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageEtancheite
        idFiche="{idFiche}"
        idBtn="6"
        titre="{'Sur le côté de ' + $dimLongueur + ' mm'}"
        soustitre=""
      />
    </div>
    <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
      <BtnPageEtancheite
        idFiche="{idFiche}"
        idBtn="7"
        titre="{'Sur le côté de ' + $dimLargeur + ' mm'}"
        soustitre=""
      />
    </div>
  </div>
{:else if idFiche == 5}
  <div class="grid grid-cols-3 gap-4">
    <div in:fly="{{ x: 100, duration: 800 }}">
      <BtnPageEtancheite
        idBtn="8"
        idFiche="{idFiche}"
        titre="{'Pousser / Lâcher'}"
      />
    </div>
  </div>
  <div in:fly="{{ delay: 300, x: 100, duration: 800 }}">
    <p class="as-info-trappe">
      La trappe sélectionnée est disponible en une seule fermeture
    </p>
  </div>
{/if}

<Paths />
